export default function encode(input: string){
  return input.replace(/[^]/g, function(char){
    return"&#"+char.charCodeAt(0)+";"
  });
}